import * as React from "react";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { CREATE_MANUAL_JOB_TITLE, DELTA_TABLE_SYNC_JOB_TYPE } from "../../Consts";
import { Dropdown, IDropdownOption } from "office-ui-fabric-react/lib/Dropdown";

export interface IDeltaTableSyncJobParametersProps {
    getDtsHighWaterMark?: () => void;
    dtsHighWaterMark?: any; 
    setDtsHighWaterMark?: (hwm: string[]) => void;
    triggerManualJob: (params: ITriggerManualJob) => void;
    updateManualJobParams?: (params: any) => void;
    scheduledJobSet?: (value: boolean) => void;
    onError?: (errorMessage: string) => void;
    createNewJob: () => void;
    checkJobsInProgress?: () => Promise<boolean>;
}

const DeltaTableSyncJobParameters = (props: IDeltaTableSyncJobParametersProps) => {
    const {
        getDtsHighWaterMark,
        dtsHighWaterMark,
        setDtsHighWaterMark,
        triggerManualJob,
        scheduledJobSet,
        onError,
        updateManualJobParams,
        createNewJob,
        checkJobsInProgress,
    } = props;
    const [jobError, setJobError] = React.useState('');
    const [selectedSyncGroups, setSelectedSyncGroups] = React.useState<string[]>(["All"]);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        getDtsHighWaterMark();
    }, []);

    const [syncGroupKeys, setSyncGroupKeys] = React.useState<string[]>([]);

    React.useEffect(() => {
        if (dtsHighWaterMark && typeof dtsHighWaterMark === "object") {
        let keys = Object.keys(dtsHighWaterMark);
        // exclude unused/old values that are in the azure.highwatermark table but are no longer used
        const excludeKeys = ["PPULicensing", "WorkNumberAdditionalSyncService", "VenueCustomerSync", "IPSync"];
        keys = keys.filter(key => !excludeKeys.includes(key));
        
        keys.sort();
        setSyncGroupKeys?.(keys);
        }
    }, [dtsHighWaterMark]);

    const syncGroupOptions = ["All", ...syncGroupKeys].map((key) => ({
        key: key,
        text: key,
    }));

    const handleSyncGroupChange = (option: IDropdownOption) => {
    const key = option.key.toString();

    if (key === "All") {
        if (selectedSyncGroups.includes("All")) {
            setSelectedSyncGroups([]);
        } else {
            setSelectedSyncGroups(["All"]);
        }
    } else {
        let newSelection = selectedSyncGroups.includes("All")
            ? [key] 
            : [...selectedSyncGroups];

        if (option.selected) {
            newSelection.push(key);
        } else {
            newSelection = newSelection.filter(k => k !== key);
        }

        setSelectedSyncGroups(newSelection);
    }
};


    const onClickStartJob = async () => {
    setLoading(true);
    setJobError(''); 

    try {
        var isRunning = await checkJobsInProgress?.(); 
        if (isRunning) {
            setJobError("DTS Job is already running, please wait for that job to complete before attempting to run another.");
            setLoading(false);
            return;
        }

        if (selectedSyncGroups.includes("UsageSync") && !selectedSyncGroups.includes("UsageGroupSync")){
            selectedSyncGroups.push("UsageGroupSync");
        }
        if (selectedSyncGroups.includes("UsageGroupSync") && !selectedSyncGroups.includes("UsageSync")){
            selectedSyncGroups.push("UsageSync");
        }
        const skipLookups = !selectedSyncGroups.includes("All") && !selectedSyncGroups.includes("LookupSync");

        const manualJobParameters: ITriggerManualJob = {
            jobType: DELTA_TABLE_SYNC_JOB_TYPE,
            jobParameters: JSON.stringify({
                customSyncList: selectedSyncGroups.includes("All") ? [] : selectedSyncGroups,
                skipLookups: skipLookups

            }),
        };

        scheduledJobSet?.(true);
        createNewJob();
        triggerManualJob(manualJobParameters);
        updateManualJobParams?.('');
    } catch (err: any) {
        onError?.(err.message || "Failed to trigger DTS job");
    } finally {
        setLoading(false);
    }
};
  return (
    <>
        <div className="row">
            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                <label>Sync Groups</label>
                <Dropdown
                    selectedKeys={
                        selectedSyncGroups.includes("All")
                            ? ["All", ...syncGroupKeys] 
                            : selectedSyncGroups
                    }   
                    options={syncGroupOptions}
                    multiSelect={true}
                    onChange={(e, option, i) => handleSyncGroupChange(option)}
                    placeholder={""}
                    disabled={false}
                    onRenderTitle={(selectedOptions) => {
                        const displayText = selectedOptions
                            .filter(opt => opt.key !== "All")
                            .map(opt => opt.text)
                            .join(", ");
                        return <span>{selectedSyncGroups.includes("All") ? "All" : displayText}</span>;
                    }}
                />
            </div>
        </div>
        
        {jobError && jobError !== '' && (
            <div className="alert alert-danger alert-dismissible" 
                style={{
                    maxWidth: '100%',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                }}
            >
                <span>{jobError}</span>
                <button type="button" className="close" aria-label="Close" onClick={() => setJobError('')}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        )}

        <div className="row">
            <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <ActionButton
                    buttonText={"Cancel"}
                    buttonAction={createNewJob}
                    className={"button btn-defaultSecondary"}
                />
            </div>
            <div className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                <ActionButton
                    buttonText={CREATE_MANUAL_JOB_TITLE}
                    buttonAction={onClickStartJob}
                    disabled={loading}
                />
            </div>
        </div>
    </>
  );
};

export default DeltaTableSyncJobParameters;